import * as React from 'react';

import CodeBlock from 'bundles/tutorials/components/CodeBlock';

type Props = {
  className: string;
  children: string;
};

const Code = ({ className, children, ...props }: Props) => {
  const match = /lang-(\w+)/.exec(className || '');
  return match ? (
    <CodeBlock codeString={String(children).replace(/\n$/, '')} language={match[1]} />
  ) : (
    <code className={className} {...props}>
      {children}
    </code>
  );
};

export default Code;
